module.exports = "mutation addOrDeleteBulkProducts($values:BulkProductCategoryInput!){addOrDeleteBulkProducts(values:$values)}"